<template>
    <c-content>
      <section class="sign u-m-auto">
        <div class="sign__body">
          <h1 class="sign__title">CompLabs</h1>
          <p class="sign__text">Login In with your administrator account</p>
          <form @submit.prevent="trytologin">
            <c-form-field label="Email">
              <c-form-input type="email" v-bind:autocomplete="'email'" v-bind:status="$v.auth.email.$error ? 'danger' : ''" v-model="auth.email"></c-form-input>
              <span v-if="submitted && !$v.auth.email.required" class="form-help u-color-danger">Email is required.</span>
              <span v-if="submitted && !$v.auth.email.email" class="form-help u-color-danger">Email is invalid.</span>
            </c-form-field>
            <c-form-field label="Password">
              <c-form-input type="password" v-bind:autocomplete="'current-password'" v-bind:status="$v.auth.password.$error ? 'danger' : ''" v-model="auth.password"></c-form-input>
              <span v-if="submitted && !$v.auth.password.required" class="form-help u-color-danger">Password is required.</span>
              <span v-if="submitted && !$v.auth.password.minLength" class="form-help u-color-danger">Password must be at least 8 characters.</span>
            </c-form-field>
            <c-form-field>
              <c-level>
                <c-form-checkbox label="Remember me" slot="left"></c-form-checkbox>
                <!--<router-link to="/auth/forgot" slot="right">Forgot Password?</router-link>-->
              </c-level>
            </c-form-field>
            <c-button type="primary" block>Login In</c-button>
          </form>
          <!--<c-divider>OR</c-divider>
          <div class="u-text-center">
            <a href="#" class="u-color-muted u-ml-10 u-mr-10"><i class="icon-facebook2"></i></a>
            <a href="#" class="u-color-muted u-ml-10 u-mr-10"><i class="icon-twitter"></i></a>
            <a href="#" class="u-color-muted u-ml-10 u-mr-10"><i class="icon-github"></i></a>
          </div>-->
        </div>
        <!--<footer class="sign__footer u-text-center">
          <p>Not have an account? <router-link to="/auth/registration">Register</router-link></p>
          <p class="u-text-muted u-fs-12">Dashboard UI kit by 20Theme<br>© 2017-2018. All RIGHT RESERVED.</p>
        </footer>-->
      </section>
    </c-content>
</template>


<script>
import { required, email, minLength } from "vuelidate/lib/validators";

export default {
    data() {
        return{
            auth: {
                email: "",
                password: ""
            },
            loadingText: "",
            submitted: false
          }
    },
    validations: {
        auth: {
            email: { required, email },
            password: { required, minLength: minLength(8) }
        }
    },
    methods: {
        trytologin: function(event) {
            
            let _this = this;
            this.submitted = true;
            this.$v.auth.$touch();
            // if its still pending or an error is returned do not submit
            if (this.$v.auth.$pending || this.$v.auth.$error) return;
            // to form submit after this

            let email = this.auth.email;
            let password = this.auth.password;

            this.$store.dispatch('login', { email, password })
            .then(() => this.$router.push('/secure/achievements/list'))
            .catch(err => {
              
              _this.$notify({
                type: 'danger',
                title: 'Login failed',
                content: 'User not found.',
                closeable: false,
                duration: 3000
              });

            })

        }
    }
}

</script>